import { ThemeProfile } from './types';

export const modernWarfareProfile: ThemeProfile = {
  pageBackground: 'theme',
  hud: {
    overlayOpacity: 0.7,
    dotsOpacity: 0.08,
    showAnimatedGrid: false,
    showGlobalScanline: true,
  },
  cards: {
    background: 'rgba(255, 255, 255, 0.03)',
    border: 'rgba(255, 255, 255, 0.08)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
  },
};
